import React, { useRef } from 'react';

import { Container, DiceExpression, DiceResultValue, DiceGroup} from './DiceResult.styles';
import DiceValue from '../DiceValue/DiceValue';
import ResultValue from '../DiceValue/ResultValue';
import DiceCouterRow from '../DiceCounterRow/DiceCounterRow';
import T from '../../../i18n/i18n';

export default function ({content, silent=false, total=false, hidden=false}) {

    const cachedDices = useRef({});

    const renderDices = (content) => {
        if (cachedDices.current[content.timestamp]) {
            return cachedDices.current[content.timestamp];
        }

        let shouldSum = false;
        let items = [];
        let expression = content.originalExpression.replace(/\s*([+\-*/()])\s*/gi,'$1');
        let index = 1;
        let dices = content.rolls.map(d => ({id:index++, ...d}));
        let hasFateDices = content.rolls.some(d => d.sides === 'F');

        let fateExpression = content.originalExpression;
        if (hasFateDices) {
            for (let i of dices) {
                if (i.sides === 'F') {
                    fateExpression = fateExpression.replace(i.expression, i.final.map(v=> v<0 ? '(-1)' : v).join('+'));
                } else {
                    fateExpression = fateExpression.replace(i.expression, i.final.join('+'));
                }
            }
        }

        
        if (total || hidden) {
            items.push(<DiceGroup key={(new Date().getTime())}>
                <DiceValue hidden={hidden} dice={{content, sides:content.maximumResult}} dices={content.rolls} title={hasFateDices ? fateExpression : content.resultExpression} expression={content.originalExpression} value={content.finalRolls} index={0} />
            </DiceGroup>);
        } else {
            for (let d of dices) {
                expression = expression.replace(d.expression, `@@::${d.id}@@`)
            }

            items = expression.split('@@').map(i => {
                if (i.substr(0,2) === '::') {
                    let dice = null;
                    for(let d of dices) {
                        if (d.id === parseInt(i.substr(2))) {
                            dice = d;
                            shouldSum = shouldSum || dice.values.length > 1;
                            break;
                        }
                    }
                    return <DiceGroup key={i}>{dice.values.map((v,i) => {
                        return <DiceValue key={dice.id +'.'+i} dice={dice} value={v} index={i} />
                    })}</DiceGroup>;
                }

                return i;
            }).filter(i => !!i);
        }

        if ((items.length > 1 || shouldSum)) {
            items.push(<ResultValue key="result" title={content.resultExpression} expression={content.originalExpression}>{content.finalResult}</ResultValue>)
        }

        cachedDices.current[content.timestamp] = items;
        return items;
    }

    const renderCounts = (content) => {
        let counterRows = [];
        for (let rolls of content.rolls) {
            if (rolls.options && rolls.options.count) {
                counterRows.push({
                    countSuccess: rolls.countSuccess,
                    countFailures: rolls.countFailures,
                    countCritical: rolls.countCritical,
                    countFail: rolls.countFail
                });
            }
        }

        if (counterRows.length <= 0) {
            return null;
        }

        return counterRows.map((counter,i) => <DiceCouterRow key={i} counter={counter} />)
    }

    return <Container>
        {!silent &&
            <DiceExpression><T value="chat.roll" />{content.parsedExpression}</DiceExpression>
        }
        <DiceResultValue>
            {renderDices(content)}
        </DiceResultValue>
        {renderCounts(content)}
    </Container>;

}